import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentChargesFormField } from './ShipmentChargesFormField'

export const ShipmentChargesSupplierDetails = ({ dataState, setDataState, disabled, style }) => {
    const { t } = useTranslation()

    const rows = [
        [
            {
                display: t('SupplierCode'),
                code: 'SupplierCode',
                type: 'foreignKey',
                entity: 'Account',
                filterField: 'AccountCode',
                labelFields: ['AccountCode'],
                fields: [
                    { key: 'AccountCode', value: 'SupplierCode' },
                    { key: 'AccountName', value: 'SupplierName' },
                    { key: 'Id', value: 'SupplierId' },
                ],
                favoritesFieldName: 'SupplierCode', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'SupplierCode', favoritesIdKey: 'SupplierId',
            },
            { display: t('SupplierName'), code: 'SupplierName', type: 'disabled', grow: true },
        ],
        [
            {
                display: t('CostCurrency'),
                code: 'CostCurrencyCode',
                type: 'foreignKey',
                entity: 'Currency',
                filterField: 'code',
                labelFields: ['Code'],
                fields: [
                    { key: 'Code', value: 'CostCurrencyCode' },
                    { key: 'Id', value: 'CostCurrencyId' },
                ],
                favoritesFieldName: 'CostCurrency', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'CostCurrencyCode', favoritesIdKey: 'CostCurrencyId',
            },
            { display: t('CostValue'), code: 'CostValue', type: 'number' },
        ],
    ]

    return (
        <M_Fieldset
            labelInside
            style={style}
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-building' style={{ fontSize: '18px' }} />
                    {t('SupplierDetails')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                    {rows.map((row, rowIndex) => (
                        <div key={rowIndex} style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                            {row.map((field, colIndex) => (
                                <ShipmentChargesFormField
                                    key={colIndex}
                                    fields={field}
                                    index={rowIndex * 10 + colIndex}
                                    data={dataState}
                                    setData={setDataState}
                                    disabled={disabled}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            }
        />
    )
}
